import { useOutletContext } from 'react-router-dom';
import { InventoryInner } from './Inventory';
import type { User } from '../api/types';

/** Wraps the legacy Inventory body so InventoryLayout owns the Header + tabs. */
export default function InventoryHealth() {
  const user = useOutletContext<User>();
  return <InventoryInner user={user} embedded />;
}
